var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"La hora","audio2":"../mp3/PrimariaC/06PC.mp3","cover":"../img/3.jpg","name":"Primaria C - Lección #6"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }